import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '../../../../global/context/SnackbarContext'
import { GetUpdateIntroducingBrokerTradingAccountRebateBulk } from '../../../../model/GetUpdateIntroducingBrokerTradingAccountRebateBulk'
import { NameDto } from '../../../../model/NameDto'
import { useApiClient } from '../../../../utils/ApiClient'
import { ClientApiClient } from '../../../../utils/clientApi'

interface UpdateIBTradingAccountsRebates {
  isLoading: boolean
  updateRebates: (payload: GetUpdateIntroducingBrokerTradingAccountRebateBulk) => Promise<
    | {
        processed: NameDto[]
        skipped: NameDto[]
      }
    | undefined
  >
}

interface UpdateIBTradingAccountsRebatesParams {
  onCompleted?: () => void
}

export const useUpdateIBTradingAccountsRebates = ({
  onCompleted,
}: UpdateIBTradingAccountsRebatesParams = {}): UpdateIBTradingAccountsRebates => {
  const apiClient = useApiClient(ClientApiClient)
  const { addSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const updateRebates = async (payload: GetUpdateIntroducingBrokerTradingAccountRebateBulk) => {
    setIsLoading(true)

    try {
      const response = await apiClient.updateIBTradingAccountsRebates(payload)

      if (response.skipped.length !== 0) {
        addSnackbar.error({
          message: t('IB.RebatesPage.Please detach TA(s) from the group first'),
        })
      } else {
        addSnackbar.success({
          message: t(
            'IB.RebatesPage.ClientsPage.You have successfully updated the rebate settings'
          ),
        })
      }

      setIsLoading(false)
      onCompleted?.()

      return response
    } catch (error: unknown) {
      setIsLoading(false)
    }
  }

  return { updateRebates, isLoading }
}
